import session from '@/shared/session'

// initial state
const initialState = () => ({
	current: null,
	patient: {
		decursus: [],
		previous: [],
	}
})

const state = initialState()

// getters
const getters = {
	getCurrentDecursus: (state) => () => {
		return state.current
	},
	getPatientPreviousDecursus: (state) => () => {
		return state.patient.previous
	},
	getPatientDecursus: (state) => () => {
		return state.patient.decursus
	}
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async getDecursusById({ commit, state }, id) {
		const decursus  = await session
			.get(`/api/decursus/${id}/`)

		commit("set_patient_decursus", decursus.data)

		return state.patient.decursus
	},

	async getDecursusForCurrentPatient({ commit, state, rootState }) {
		if (!rootState.patients.current) {
			return
		}
		
		const decursus  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/decursus/`)

		commit("set_patient_decursus", decursus.data)

		return state.patient.decursus
	},

	async getPreviousDecursusForCurrentConsult({ commit, state, rootState }) {
		if (!rootState.schedule.current?.consultation) {
			return
		}

		const previous = await session
		.get(`/api/planning/consultations/${rootState.schedule.current?.consultation?.id}/previous_decursus/`)

		commit("set_previous", previous.data)

		return state.patient.previous
	},	

	async getPreviousDecursusByConsultationId({ commit, state }, id) {
		const previous = await session
		.get(`/api/planning/consultations/${id}/previous_decursus/`)

		commit("set_previous", previous.data)

		return state.patient.previous
	},

	async getCurrentDecursusForConsultation({ commit, state, rootState }) {
		if (!rootState.schedule.current?.consultation) {
			return
		}

		const current = await session
		.get(`/api/planning/consultations/${rootState.schedule.current?.consultation?.id}/current_decursus/`)

		commit("set_current", current.data)

		return state.current
	},

	async getCurrentDecursusByConsultationId({ commit, state, dispatch }, id) {
		dispatch("loading/load", "decursus", { root: true })

		const current = await session
		.get(`/api/planning/consultations/${id}/current_decursus/`)

		commit("set_current", current.data)

		dispatch("loading/end", "decursus", { root: true })

		return state.current
	},

	// async getDecursusByConsultationId({ commit, state }, id) {
	// 	const [previous, current] = await Promise.all([
	// 		session.get(`/api/planning/consultations/${id}/previous_decursus/`),
	// 		session.get(`/api/planning/consultations/${id}/current_decursus/`),
	// 	])

	// 	commit("set_previous", previous.data)
	// 	commit("set_current", current.data)

	// 	return state.current
	// },

	updateDecursus({ commit, dispatch, state }, {notify, data}) {
		if (notify) {
			dispatch("loading/load", "current_decursus", { root: true })
		}
		return session
			.patch(`/api/decursus/${state.current?.id}/`, data)
			.then((current) => {
				commit("set_current", current.data)
				return dispatch('schedule/updateConsultationEpisode', data.episode, { root: true })
			})
			.then(() => {
				return dispatch('getDecursusForCurrentPatient')
			})
			.finally(() => {
				if (notify) {
					dispatch("loading/end", "current_decursus", { root: true })
				}
			})
	}
}

// mutations
const mutations = {
    reset_state(state) {
		Object.assign(state, initialState())
    },
	set_current(state, current) {
		state.current = current
	},
	set_previous(state, decursus) {
		state.patient.previous = decursus
	},
	set_patient_decursus(state, decursus) {
		state.patient.decursus = decursus
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}